import { styled, Typography } from '@mui/material'
import RentalNew from '@src/components/orbitalTrack/rentalSetting/common/RentalNew'
import RentalSettingDialog, {
  RentalType
} from '@src/components/orbitalTrack/rentalSetting/common/RentalSettingDialog'
import { useOrbitalTrackAttachContext } from '@src/contexts/orbitalTrack/OrbitalTrackAttachContext'
import { FC, useCallback, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

const InvitedCount = styled(Typography)`
  font-weight: 700;

  strong {
    color: #ffbf36;
    font-weight: 700;
  }
`

const InviteRentalNew: FC = () => {
  const { t } = useTranslation()

  const { refetchStar, trackDetail } = useOrbitalTrackAttachContext()

  const [open, setOpen] = useState<boolean>(false)

  const handleOnClick = useCallback(() => {
    setOpen(true)
  }, [setOpen])

  const handleOnClose = useCallback(
    (success: boolean) => {
      setOpen(false)
      if (success) {
        refetchStar()
      }
    },
    [refetchStar]
  )

  return (
    <RentalNew
      title={t('godiverse.orbital_track.invite_track')}
      description={t('godiverse.orbital_track.about_invite_track')}
      dialog={
        <RentalSettingDialog
          rentalType={RentalType.INVITE}
          open={open}
          onClose={handleOnClose}
        />
      }
      onNewClick={handleOnClick}
      buttonText={t('godiverse.orbital_track.new_invite')}
      subTitle={
        <InvitedCount>
          <Trans>
            {t('godiverse.orbital_track.total_invited_group', {
              count: trackDetail?.inviteSettings.length,
              maxLimit: 50
            })}
          </Trans>
        </InvitedCount>
      }
      variant='invite'
    />
  )
}

export default InviteRentalNew
